export default __webpack_public_path__ + "static/quote-card-2-30af0e9f85147ab8962f4206980f0eacbc713c2bee8c0ba647aa55e2b761e088.png";